import Avatar from "./basic-17-avatar.png";
import LogoPlaceholder from "./logo-placeholder.png";
import Slide1 from "./preview/slide-1.png";
import Slide2 from "./preview/slide-2.png";
import Slide3 from "./preview/slide-3.png";
import Slide4 from "./preview/slide-4.png";
import Slide5 from "./preview/slide-5.png";
import BgOption1 from "./../images/bg-option-1.png";
import BgOption2 from "./../images/bg-option-2.png";
import BgOption3 from "./../images/bg-option-3.png";
import { MultilineView, TextView } from "../../components";
import TemplateImage from "./template-image.png";
import BaseTemplate from "../base";

class Basic17 extends BaseTemplate {
  constructor() {
    super();
    this.name = "Basic #17";
    this.id = "17";
    this.url = "/ai/carousels/basic-17";
    this.description =
      "Create a simple and sleek carousel without the need for your image";
    this.common_settings = {
      elements: [
        {
          label: "Your Name",
          type: "text",
          value: "Jon Snow",
        },
        {
          label: "Profile Pic",
          type: "logo",
          key: "logo",
          value: {
            type: "image",
            image: Avatar,
          },
        },
        {
          label: "Handle",
          type: "text",
          value: "@jon-snow",
        },
        {
          label: "Background",
          type: "background",
          key: "background_color",
          value: {
            type: "color",
            image: "",
            color: "#F2FFD5",
            color_options: [
              "#2cd4bf",
              "#38bcf7",
              "#feb022",
              "#f87066",
              "#33d583",
              "#818cf8",
              "#f471b6",
              "#bf84fc",
            ],
            image_options: [
              {
                image: BgOption1,
              },
              {
                image: BgOption2,
              },
              {
                image: BgOption3,
              },
            ],
          },
        },
        {
          label: "Primary Color",
          type: "color",
          key: "primary_color",
          style_key_group: "primary",
          value: "#000000",
        },
        {
          label: "Primary Font",
          key: "primary_font",
          value: "Onest",
          type: "font",
        },
      ],
      swipe_indicator: {
        image: "",
      },
    };
    this.preview_images = [Slide1, Slide2, Slide3, Slide4, Slide5];
    this.slides = [
      {
        elements: [
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Email is THE best way to grow your business.
            
• More sales 
• Better relationships 
• No algorithm problems

Here are the ll most popular email subject lines I sent during my recent 6 figure launches (swipe for inspiration):`,
            max_words: 25,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "20px",
              },
              fontFamily: {
                key: "primary_font",
              },
            },
          },
        ],
        slide_type: "intro",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            value: "TOPICAL AND CONTROVERSIAL",
            type: "text",
            max_words: 5,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "20px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "600",
              },
            },
          },
          {
            label: "Subtitle",
            target_key: "title",
            value: "IS ELON MUSK RUINING TWITTER?",
            type: "text",
            max_words: 5,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "16px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "600",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `People love controversial current events. Keep an eye out for what's happening in the world - even better if it's in your niche - then use it as the hook to share your idea.`,
            max_words: 25,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "14px",
              },
              fontFamily: {
                key: "primary_font",
              },
            },
          },
          {
            label: "Image(Recommended size 400 x 200)",
            target_key: "image",
            type: "image",
            value: TemplateImage,
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            value: "USE A MENTOR",
            type: "text",
            max_words: 5,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "20px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "600",
              },
            },
          },
          {
            label: "Subtitle",
            target_key: "title",
            value: "THE DAY NAVAL RAVIKANT SLAPPED ME IN THE FACE",
            type: "text",
            max_words: 5,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "16px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "600",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Build authority by association by using names in your niche. BUT make sure you're the star of the show. People are here for your ideas.`,
            max_words: 25,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "14px",
              },
              fontFamily: {
                key: "primary_font",
              },
            },
          },
          {
            label: "Image(Recommended size 400 x 200)",
            target_key: "image",
            type: "image",
            value: TemplateImage,
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            value: "USE THE COMPETITION",
            type: "text",
            max_words: 5,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "20px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "600",
              },
            },
          },
          {
            label: "Subtitle",
            target_key: "title",
            value: "I GOT INTO A BAR FIGHT WITH JUSTIN WELSH AND DAN KOE",
            type: "text",
            max_words: 5,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "16px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "600",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `You need a different point of view to stand out. But the secret isn't to attack other creators. It's to shed new light on an old concept.`,
            max_words: 25,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "14px",
              },
              fontFamily: {
                key: "primary_font",
              },
            },
          },
          {
            label: "Image(Recommended size 400 x 200)",
            target_key: "image",
            type: "image",
            value: TemplateImage,
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "CTA Text",
            type: "text",
            target_key: "cta_text",
            value: "Thanks for reading!",
            max_words: 2,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "24px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "600",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `If you enjoyed this, come join 25,000+ creators reading my newsletter Digital Freedom and get weekly actionable advice to build your creator business.`,
            max_words: 25,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "20px",
              },
              fontFamily: {
                key: "primary_font",
              },
            },
          },
        ],
        slide_type: "outro",
      },
    ];
  }

  setCommonSettings(settings) {
    this.common_settings = settings;
  }

  getPrimaryColor(common_settings) {
    return common_settings.elements[4].value;
  }

  getBackgroundColor(common_settings) {
    return common_settings.elements[3].value.color;
  }

  getBackgroundColorVariant(common_settings) {
    return this.getBackgroundColor(common_settings) + "20";
  }

  getBackgroundColorVariantSecond(common_settings) {
    return this.getBackgroundColor(common_settings) + "40";
  }

  getPrimaryFont(common_settings) {
    return common_settings.elements[5]?.value || "Onest";
  }

  duplicateSlide(slide, index) {
    let new_slide = JSON.parse(JSON.stringify(slide));
    this.slides.splice(index + 1, 0, new_slide);
    return new_slide;
  }

  renderOutroSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <>
        <div className="flex flex-col gap-[16px]">
          <div
            className="text-[24px] leading-[32px] font-semibold"
            style={{
              color: this.getPrimaryColor(commonSettings),
            }}
          >
            {slide.elements[0]?.style ? (
              <MultilineView
                element={slide.elements[0]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[0]?.value} />
            )}
          </div>

          <div
            className="text-[20px] leading-[30px] font-normal"
            style={{
              color: this.getPrimaryColor(commonSettings),
            }}
          >
            {slide.elements[1]?.style ? (
              <MultilineView
                element={slide.elements[1]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[1]?.value} />
            )}
          </div>
        </div>
        <svg
          width="97"
          height="20"
          viewBox="0 0 97 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20 10.2715C19.9397 12.8956 18.89 15.3646 16.7644 17.3557C15.7925 18.2662 14.6695 18.9393 13.4193 19.3929C12.0507 19.8904 10.5899 20.0826 9.1393 19.9559C7.68869 19.8292 6.2833 19.3867 5.02156 18.6595C4.92447 18.6036 4.846 18.6213 4.75437 18.6548C3.57485 19.0849 2.39532 19.5167 1.21407 19.9408C0.863685 20.0665 0.540869 19.9904 0.276656 19.7286C0.00871841 19.463 -0.0672676 19.1375 0.060369 18.7815C0.489467 17.5835 0.923034 16.3871 1.36107 15.1924C1.37514 15.1587 1.38069 15.1221 1.37723 15.0857C1.37376 15.0494 1.36139 15.0144 1.34121 14.984C0.912669 14.2471 0.582648 13.457 0.359595 12.6342C0.0714628 11.591 -0.0428892 10.5074 0.0211344 9.42699C0.151585 7.27478 0.89398 5.36025 2.24832 3.68341C3.33422 2.34179 4.68831 1.35223 6.29222 0.712482C7.66774 0.160784 9.14935 -0.075481 10.6281 0.021055C14.4555 0.256582 17.8163 2.67595 19.2632 6.24166C19.7514 7.44389 19.9898 8.69681 20 10.2715Z"
            fill={this.getPrimaryColor(commonSettings)}
          />
          <path
            d="M55.2253 0.45459C52.1855 0.45459 50.5003 2.62897 50.5003 2.62897C50.5003 2.62897 48.815 0.45459 45.7753 0.45459C42.5854 0.45459 40.0002 3.01598 40.0002 6.17663C40.0002 10.516 45.1579 14.7212 46.5953 16.0498C48.2512 17.5791 50.5003 19.5454 50.5003 19.5454C50.5003 19.5454 52.7494 17.5791 54.4052 16.0498C55.8427 14.7212 61.0003 10.516 61.0003 6.17663C61.0003 3.01598 58.4152 0.45459 55.2253 0.45459Z"
            fill={this.getPrimaryColor(commonSettings)}
          />
          <path
            d="M96.2734 18.4153C96.2734 18.8843 95.7403 19.1543 95.3622 18.8769L88.9757 14.1911C88.7742 14.0433 88.4999 14.0433 88.2984 14.1911L81.9119 18.8769C81.5338 19.1543 81.0007 18.8843 81.0007 18.4153V1.0271C81.0007 0.710912 81.2571 0.45459 81.5732 0.45459H95.7009C96.0171 0.45459 96.2734 0.710912 96.2734 1.0271V18.4153Z"
            fill={this.getPrimaryColor(commonSettings)}
          />
        </svg>
      </>
    );
  }

  renderMiddleSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <>
        <div className="flex flex-col gap-[16px]">
          <div
            className="text-[20px] leading-[30px] font-semibold"
            style={{
              color: this.getPrimaryColor(commonSettings),
            }}
          >
            {slide.elements[0]?.style ? (
              <MultilineView
                element={slide.elements[0]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[0]?.value} />
            )}
          </div>
          <div className="flex flex-col gap-[4px]">
            <div
              className="text-[16px] leading-[28px] font-semibold"
              style={{
                color: this.getPrimaryColor(commonSettings),
              }}
            >
              {slide.elements[1]?.style ? (
                <MultilineView
                  element={slide.elements[1]}
                  getPropertyByStyleKey={(styleKey) =>
                    this.getPropertyByStyleKey(styleKey, commonSettings)
                  }
                  getValueByKey={(key) =>
                    this.getValueByKey(key, commonSettings)
                  }
                />
              ) : (
                <TextView text={slide.elements[1]?.value} />
              )}
            </div>
            <div
              className="text-[14px] leading-[20px] font-normal"
              style={{
                color: this.getPrimaryColor(commonSettings),
              }}
            >
              {slide.elements[2]?.style ? (
                <MultilineView
                  element={slide.elements[2]}
                  getPropertyByStyleKey={(styleKey) =>
                    this.getPropertyByStyleKey(styleKey, commonSettings)
                  }
                  getValueByKey={(key) =>
                    this.getValueByKey(key, commonSettings)
                  }
                />
              ) : (
                <TextView text={slide.elements[2]?.value} />
              )}
            </div>
          </div>
          <img
            className="object-cover w-[281px] h-[164px]"
            src={slide.elements[3]?.value || TemplateImage}
            alt=""
          />
        </div>
      </>
    );
  }

  renderIntroSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <>
        <div>
          <div
            className="text-[20px] leading-[30px] font-normal"
            style={{
              color: this.getPrimaryColor(commonSettings),
            }}
          >
            {slide.elements[0]?.style ? (
              <MultilineView
                element={slide.elements[0]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[0]?.value} />
            )}
          </div>
        </div>
      </>
    );
  }

  renderSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <div
        key={index}
        className={
          "carousel-slide-container ring-1 ring-gray-200 bg-white relative shrink-0 aspect-[4/5] flex flex-col items-center justify-center w-[400px] h-[500px] overflow-hidden " +
          (index !== currentSlide ? "hidden" : "") +
          " index-" +
          index
        }
        style={{
          fontFamily: this.getPrimaryFont(commonSettings),
        }}
      >
        <div className="absolute inset-0">
          {commonSettings.elements[3].value.type === "image" &&
            commonSettings.elements[3].value.image && (
              <img
                className="object-cover w-full h-full"
                src={commonSettings.elements[3].value.image}
                alt=""
              />
            )}
          {commonSettings.elements[3].value.type === "color" && (
            <div
              className="w-full h-full"
              style={{
                backgroundColor: this.getBackgroundColor(commonSettings),
              }}
            ></div>
          )}
        </div>
        <div
          className="relative w-[368px] h-[468px] p-[24px] border-[2px] flex flex-col gap-[20px]"
          style={{
            borderColor: this.getPrimaryColor(commonSettings),
          }}
        >
          <div className="flex h-[40px] items-center gap-[8px]">
            <img
              className="object-cover w-[40px] h-[40px] rounded-full"
              src={
                commonSettings.elements[1].value.image
                  ? commonSettings.elements[1].value.image
                  : LogoPlaceholder
              }
              style={{
                backgroundColor: this.getPrimaryColor(commonSettings),
              }}
              alt=""
            />
            <div className="flex flex-col">
              <p
                className="text-[16px] leading-[24px] font-semibold "
                style={{ color: this.getPrimaryColor(commonSettings) }}
              >
                {commonSettings.elements[0].value}
              </p>
              <p
                className="text-[8x] leading-[18px] font-[300px]"
                style={{ color: this.getPrimaryColor(commonSettings) }}
              >
                {commonSettings.elements[2].value}
              </p>
            </div>
          </div>
          <div
            className="w-full border-b-[2px]"
            style={{
              borderColor: this.getPrimaryColor(commonSettings),
            }}
          />
          {index === 0 &&
            this.renderIntroSlide(
              slide,
              index,
              currentSlide,
              carouselLength,
              commonSettings,
              updateSlideElementPosition,
              updateSlideElementSize,
              setCurrentSlideElement,
              previewMode
            )}
          {index === carouselLength - 1 &&
            this.renderOutroSlide(
              slide,
              index,
              currentSlide,
              carouselLength,
              commonSettings,
              updateSlideElementPosition,
              updateSlideElementSize,
              setCurrentSlideElement,
              previewMode
            )}
          {index !== carouselLength - 1 &&
            index !== 0 &&
            this.renderMiddleSlide(
              slide,
              index,
              currentSlide,
              carouselLength,
              commonSettings,
              updateSlideElementPosition,
              updateSlideElementSize,
              setCurrentSlideElement,
              previewMode
            )}
          {index !== carouselLength - 1 && (
            <div className="absolute bottom-0 right-0">
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  width="40"
                  height="40"
                  fill={this.getPrimaryColor(commonSettings)}
                />
                <path
                  d="M23.4763 19.1666L19.0063 14.6966L20.1848 13.5181L26.6666 19.9999L20.1848 26.4817L19.0063 25.3032L23.4763 20.8332H13.3333V19.1666H23.4763Z"
                  fill={this.getBackgroundColor(commonSettings)}
                />
              </svg>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default Basic17;
